module.exports = __webpack_public_path__ + "static/media/kitchen-corner.d8ea60cf.jpg";